module.exports = __webpack_public_path__ + "static/media/onboarding_faktszerz.6957ebe9.svg";